// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Ericsson and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

#kb-main-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#kb-table-container {
  flex: 1;
  overflow: auto;
}

.fuzzy-match {
  font-weight: 600;
  color: var(--theia-list-highlightForeground);
}

.kb-actions {
  text-align: center;
  vertical-align: middle;
}

.kb-action-item {
  visibility: hidden;
}

.kb table {
  border-spacing: 0;
  border-collapse: separate;
  background-color: var(--theia-editor-background);
  width: 100%;
  table-layout: fixed;
}

.kb table tr {
  min-height: var(--theia-icon-size);
}

.th-action,
.th-keybinding,
.kb-actions,
.kb-keybinding {
  min-height: 18px;
  overflow: hidden;
  vertical-align: middle;
  white-space: nowrap;
}

.th-action,
.kb-actions {
  padding: 2px 0px 5px 0px;
}

.th-keybinding,
.kb-keybinding {
  padding: 2px 10px 5px 10px;
}

.th-label,
.th-source,
.th-context,
.th-keybinding,
.kb-label,
.kb-source,
.kb-context {
  padding: 2px 10px 5px 10px;
  min-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}

.kb table th {
  font-size: var(--theia-ui-font-size1);
}

.kb table td code {
  font-size: 90%;
}

.td-source {
  text-transform: lowercase;
}

.kb table tr:nth-child(odd) {
  background-color: rgba(130, 130, 130, 0.04);
}

.kb table tbody tr:hover {
  background-color: var(--theia-list-focusBackground);
}

.kb table tbody tr:hover .kb-action-item {
  visibility: visible;
  color: var(--theia-icon-foreground);
  text-decoration: none;
}

.kb table th {
  word-break: keep-all;
  padding-bottom: 5px;
  padding-top: 5px;
  text-align: left;
  vertical-align: middle;
  position: sticky;
  top: 0;
  background-color: var(--theia-editorWidget-background);
  text-transform: capitalize;
}

.kb table .th-action {
  width: 4%;
}

.kb table .th-label {
  width: 25%;
}

.kb table .th-keybinding {
  width: 20%;
}

.kb table .th-source {
  width: 10%;
}

.kb table .th-context {
  width: 25%;
}

.no-kb {
  border: 1px solid var(--theia-editorWarning-foreground);
}

#search-kb {
  height: 25px;
  flex: 1;
}

.vs #search-kb {
  border: 1px solid #ddd;
}

.search-kb-container {
  padding: 10px;
  display: flex;
}

.kb-item-row td a,
.kb-item-row td a:active,
.kb-item-row td a:focus {
  outline: 0;
  border: none;
}

.kb-actions-icons {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/keymaps/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gDAAgD;EAChD,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;EAIE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;;;EAGE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Ericsson and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n#kb-main-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n#kb-table-container {\n  flex: 1;\n  overflow: auto;\n}\n\n.fuzzy-match {\n  font-weight: 600;\n  color: var(--theia-list-highlightForeground);\n}\n\n.kb-actions {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.kb-action-item {\n  visibility: hidden;\n}\n\n.kb table {\n  border-spacing: 0;\n  border-collapse: separate;\n  background-color: var(--theia-editor-background);\n  width: 100%;\n  table-layout: fixed;\n}\n\n.kb table tr {\n  min-height: var(--theia-icon-size);\n}\n\n.th-action,\n.th-keybinding,\n.kb-actions,\n.kb-keybinding {\n  min-height: 18px;\n  overflow: hidden;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.th-action,\n.kb-actions {\n  padding: 2px 0px 5px 0px;\n}\n\n.th-keybinding,\n.kb-keybinding {\n  padding: 2px 10px 5px 10px;\n}\n\n.th-label,\n.th-source,\n.th-context,\n.th-keybinding,\n.kb-label,\n.kb-source,\n.kb-context {\n  padding: 2px 10px 5px 10px;\n  min-height: 18px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.kb table th {\n  font-size: var(--theia-ui-font-size1);\n}\n\n.kb table td code {\n  font-size: 90%;\n}\n\n.td-source {\n  text-transform: lowercase;\n}\n\n.kb table tr:nth-child(odd) {\n  background-color: rgba(130, 130, 130, 0.04);\n}\n\n.kb table tbody tr:hover {\n  background-color: var(--theia-list-focusBackground);\n}\n\n.kb table tbody tr:hover .kb-action-item {\n  visibility: visible;\n  color: var(--theia-icon-foreground);\n  text-decoration: none;\n}\n\n.kb table th {\n  word-break: keep-all;\n  padding-bottom: 5px;\n  padding-top: 5px;\n  text-align: left;\n  vertical-align: middle;\n  position: sticky;\n  top: 0;\n  background-color: var(--theia-editorWidget-background);\n  text-transform: capitalize;\n}\n\n.kb table .th-action {\n  width: 4%;\n}\n\n.kb table .th-label {\n  width: 25%;\n}\n\n.kb table .th-keybinding {\n  width: 20%;\n}\n\n.kb table .th-source {\n  width: 10%;\n}\n\n.kb table .th-context {\n  width: 25%;\n}\n\n.no-kb {\n  border: 1px solid var(--theia-editorWarning-foreground);\n}\n\n#search-kb {\n  height: 25px;\n  flex: 1;\n}\n\n.vs #search-kb {\n  border: 1px solid #ddd;\n}\n\n.search-kb-container {\n  padding: 10px;\n  display: flex;\n}\n\n.kb-item-row td a,\n.kb-item-row td a:active,\n.kb-item-row td a:focus {\n  outline: 0;\n  border: none;\n}\n\n.kb-actions-icons {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
